import React from "react";
import style from "../../styles/tools.module.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-multi-lang";

export default function DetailsSection() {
  const d = useTranslation();
  const daynight = useSelector((state) => state.data.dayNight);

  return (
    <section
      class={`${style.detailsSection} ${daynight ? style.nightMode : ""}`}
    >
      <div class="container">
        <div class="row">
          <div class="col-lg-8 mx-auto">
            <h2 class="subHeading">{d("toolsapi.subtitleplugins")}</h2>
            <div class={`row mt-4 ${style.customRow}`}>
              {/*
              
              <div class="col-lg-6">
                <a class="commonLink" href="#">
                  Mobile App iOS <i class="fas fa-external-link-alt"></i>
                </a>
                <div class={style.oddText}>{d("toolsapi.subtitleiOS")}</div>
              </div>
              <div class="col-lg-6">
                <a class="commonLink" href="#">
                  Mobile App Android <i class="fas fa-external-link-alt"></i>
                </a>
                <div class={style.oddText}>{d("toolsapi.subtitleAndroid")}</div>
              </div>
              {/*
              <div class="col-lg-6">
                <a class="commonLink" href="#">
                  Zapier Integration<i class="fas fa-chevron-right"></i>
                </a>
                <div class={style.oddText}>Connect 2,000+ apps with ease</div>
              </div>
              */}
              <div class="col-lg-6">
                <a class="commonLink" href="https://github.com/dioptify/cli">
                  Command-line interface<i class="fas fa-external-link-alt"></i>
                </a>
                <div class={style.oddText}>{d("toolsapi.subtitleCLI")}</div>
              </div>
              {/*
              <div class="col-lg-6">
                <a class="commonLink" href="#">
                  GIMP Plugin<i class="fas fa-external-link-alt"></i>
                </a>
                <div class={style.oddText}>{d("toolsapi.subtitleGIMP")}</div>
              </div>
              <div class="col-lg-6">
                <a class="commonLink" href="#">
                  VSCode Plugin<i class="fas fa-external-link-alt"></i>
                </a>
                <div class={style.oddText}>{d("toolsapi.subtitleVSCode")}</div>
              </div>
              <div class="col-lg-6">
                <a class="commonLink" href="#">
                  Sketch 5 Plugin<i class="fas fa-external-link-alt"></i>
                </a>
                <div class={style.oddText}>{d("toolsapi.subtitleSketch5")}</div>
              </div>
              <div class="col-lg-6">
                <a class="commonLink" href="#">
                  Photoshop CC Plugin<i class="fas fa-external-link-alt"></i>
                </a>
                <div class={style.oddText}>{d("toolsapi.subtitlePSCC")}</div>
              </div>
              <div class="col-lg-6">
                <a class="commonLink" href="#">
                  Photoshop CS5 Plugin<i class="fas fa-external-link-alt"></i>
                </a>
                <div class={style.oddText}>{d("toolsapi.subtitlePSCS5")}</div>
              </div>
              <div class="col-lg-6">
                <a class="commonLink" href="#">
                  Office365<i class="fas fa-chart-line"></i>
                </a>
                <div class={style.oddText}>{d("toolsapi.subtitleOffice365")}</div>
              </div>
              */}
              {/*
              <div class="col-lg-6">
                <a class="commonLink" href="#">
                  Interomat Integration<i class="fas fa-chevron-right"></i>
                </a>
                <div class={style.oddText}>
                  Flexibly connect hundreds of services
                </div>
              </div>
              */}
            </div>
            {/*
            <h2 class="subHeading mt-4">Plugins by the dioptify community</h2>
            <div class="commonText">
              Check out these community-made plugins to use dioptify in <br />
              your favorite design tool or ecommerce platform.
            </div>
            <div class={`row mt-4 ${style.customRow}`}>
              <div class="col-lg-6">
                <a class="commonLink" href="#">
                  Plugin for Figma<i class="fas fa-chevron-right"></i>
                </a>
                <div class={style.oddText}>by @aaroniker</div>
              </div>
              <div class="col-lg-6">
                <a class="commonLink" href="#">
                  Plugin for Sketch<i class="fas fa-chevron-right"></i>
                </a>
                <div class={style.oddText}>by @mathieudutour</div>
              </div>
              <div class="col-lg-6">
                <a class="commonLink" href="#">
                  Plugin for WooCommerce<i class="fas fa-chevron-right"></i>
                </a>
                <div class={style.oddText}>by @avs2738</div>
              </div>
              <div class="col-lg-6">
                <a class="commonLink" href="#">
                  Plugin for Visual Studio Code
                  <i class="fas fa-chevron-right"></i>
                </a>
                <div class={style.oddText}>by @antonholmberg</div>
              </div>
              <div class="col-lg-6">
                <a class="commonLink" href="#">
                  Plugin for Drupal<i class="fas fa-chevron-right"></i>
                </a>
                <div class={style.oddText}>by david.froehlich</div>
              </div>
              <div class="col-lg-6">
                <a class="commonLink" href="#">
                  Plugin for Shopware 5<i class="fas fa-chevron-right"></i>
                </a>
                <div class={style.oddText}>by @karlbauerde</div>
              </div>
            </div>
            */}
          </div>
        </div>
      </div>
    </section>
  );
}
